{
  "notFoundTitle": "ページが見つかりません",
  "notFoundBody": "このオークションロットは存在しないか、取り下げられました。",
  "backToAuctions": "オークション一覧に戻る",
  "genericTitle": "問題が発生しました",
  "genericBody": "もう一度お試しいただくか、ホームにお戻りください。",
  "goHome": "ホームに戻る",
  "offline": "オフラインのようです。",
  "emptyTitle": "表示する内容はまだありません。",
  "loadFailed": "現在読み込めませんでした。",
  "tryAgain": "再試行",
  "routeErrorTitle": "問題が発生しました",
  "routeErrorBody": "このページを読み込めませんでした。もう一度お試しください。問題が解決しない場合は、前のページに戻るかホームにお戻りください。",
  "retry": "再試行",
  "back": "戻る",
  "notFound404": "404",
  "notFoundHeading": "ページが見つかりません",
  "notFoundDetail": "お探しのページは存在しないか、移動された可能性があります。",
  "home": "ホーム",
  "searchAuctions": "オークションを探す",
  "retrying": "再試行中…"
}
